import React from 'react'
import styled from 'styled-components'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import RoundedBox from '../RoundedBox'
import application from './assets/application.png'
import application2x from './assets/application@2x.png'
import lightNode from './assets/light-node.png'
import lightNode2x from './assets/light-node@2x.png'
import node from './assets/node.png'
import node2x from './assets/node@2x.png'
import Topic from '~shared/Topic'
import Container from '~shared/Container'
import Br from '~shared/Br'

const IconContainer = styled.div`
    position: relative;
    width: 120px;
    height: 120px;

    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }

    @media ${MqTablet} {
        width: 138px;
        height: 138px;
    }

    @media ${MqDesktop} {
        width: 192px;
        height: 192px;
    }
`

const Slide1 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>
                Connect your app
                <Br mobile />
                to the Network
            </Topic.Title>
            <Topic.Paragraph>
                Applications always access the Streamr Network via a node. JS-based applications,
                including the browser will run a node inside your application. Non-JS based
                environments interface with Streamr nodes with standard protocols.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={application} srcSet={application2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide2 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>Streamr SDK</Topic.Title>
            <Topic.Paragraph>
                By using the Streamr SDK, a Streamr node will run natively inside your application,
                but this approach can only be used in JS-based environments at the moment. This
                library is distributed as an npm package.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={lightNode} srcSet={lightNode2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide3 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>Streamr node</Topic.Title>
            <Topic.Paragraph>
                If your application is written in other programming languages, run a Streamr node as
                a separate process, and your application will interact with it over MQTT, HTTP or
                WebSocket. The Streamr node is distributed as a Docker image or as an npm package.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={node} srcSet={node2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const UnstyledConnectToNetwork = (props) => (
    <div {...props}>
        <Container>
            <Topic.Title $appear>
                <a href="#get-started-with-the-streamr-network">
                    Get started with the Streamr Network
                </a>
            </Topic.Title>
            <Topic.Paragraph $appear>
                Truly decentralised innovation with real-time data applications is enabled by
                Streamr&apos;s P2P network and companion blockchain settlement layer.
            </Topic.Paragraph>
        </Container>
        <RoundedBox.Gallery items={[Slide1, Slide2, Slide3]} />
    </div>
)

const ConnectToNetwork = styled(UnstyledConnectToNetwork)`
    ${Topic.Title} {
        margin: 0;
        margin-bottom: 2rem;
        text-align: left;
    }

    > ${Container} {
        margin-bottom: 4rem;
    }

    @media ${MqTablet} {
        > ${Container} {
            ${Topic.Title} {
                text-align: center;
            }

            ${Topic.Paragraph} {
                margin: 0 auto;
                max-width: 38rem;
                text-align: center;
            }
        }

        > ${Container} {
            padding: 0;
        }
    }

    @media ${MqDesktop} {
        > ${Container} {
            margin-bottom: 7rem;
        }
    }
`

export default ConnectToNetwork
